import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Student } from '@app/models/users'
import Timer from 'react-compound-timer'
import SVG from 'react-inlinesvg'
import clocks from '@icons/clocks/white'

const FormattedSeconds = () => (
  <Timer.Seconds
    formatValue={(value) => `${value < 10 ? '0' : ''}${value}`}
  />
)

class Countdown extends Component {
  constructor(props) {
    super(props)
    this.handleStop = this.handleStop.bind(this)
  }

  handleStop() {
    setTimeout(() => { window.location.reload() }, 500);
  }

  render() {
    const { student: { participation } } = this.props
    if (!participation) { return null }

    return (
      <div className="countdown">
        <SVG src={clocks} />
        <div className="countdown__time">

          <Timer
            lastUnit="m"
            initialTime={participation.timeRemaining * 1000}
            direction="backward"
            checkpoints={[
              {
                time: 0,
                callback: this.handleStop
              }
            ]}
          >
            <Timer.Minutes />
            &nbsp;:&nbsp;
            <FormattedSeconds />
          </Timer>
        </div>
      </div>
    )
  }
}

Countdown.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired
}

export default Countdown
